import ScoreAnnotationWidget from "../ScoreAnnotationWidget";
import renderInline from "./renderInline";

export default function MeasureClickWidget({
  prompt,
  stimulus,
  value = {},
  onChange,
  correct,
  mode,
  feedback
}) {

  // 🔧 Adapter: merge instead of replace
  // function handleChange(next) {
  //   console.log("CURRENT VALUE:", value);
  //   console.log("NEXT:", next);
  //   onChange(next);
  // }

  function handleChange(next) {
    if (next == null) {
      onChange({});
      return;
    }

    onChange({
      ...value,
      ...next
    });
  }

  return (
    <div className="measure-click-widget">
      {/* Prompt */}
      {prompt && (
        <p style={{ fontWeight: 600, marginBottom: 12 }}>
          {Array.isArray(prompt)
            ? prompt.map(renderInline)
            : prompt}
        </p>
      )}

      {/* Score */}
      <ScoreAnnotationWidget
        config={stimulus}
        value={value}
        onChange={handleChange}
        mode={mode}
        feedback={feedback}
        hideFB={true}
      />
    </div>
  );
}